import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsPeopleRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-people',
	path: '/plugins/servlet/project-config/:projectKey/people',
};
